import React, { useState, useEffect, useRef } from 'react'
import './Inventory.css'
import { Box, Button, Typography } from "@mui/material";
import ApiService from '../../functions/apiService';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import { toast } from 'react-toastify';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { Link } from "react-router-dom";
import * as go from "gojs";
import { useNavigate } from 'react-router-dom';

const SuggestionBox = () => {
    const [parentName , setParentName] = useState('')
    const diagramRef = useRef(null);
    const diagramInstance = useRef(null);
    const navigate = useNavigate()

    let loadParentData = () => {
        ApiService.get('/get-parent-location').then((data) => {
            setParentName(data?.data?.data?.location_description || '')
        }).catch((e) => {
            console.error("error")
        })
   }

    const loadData = () => {
        ApiService.get('/get-inventory-suggestion')
            .then((response) => {
            const apiData = response?.data || [];

            const nodes = [{
                key: parentName,
                name: parentName
            }];

            apiData.forEach((station, stationIndex) => {
                const stationKey = `station-${stationIndex}`; // unique key via index

                nodes.push({
                key: stationKey,
                parent: parentName,
                name: station.station_name // visible name
                });

                (station.vehicles || []).forEach((vehicle, vehicleIndex) => {
                nodes.push({
                    key: `station-${stationIndex}-vehicle-${vehicleIndex}`, // unique key
                    parent: stationKey,
                    name: vehicle.vehicle_name // shown name stays untouched
                });
                });
            });

            if (diagramInstance.current) {
                diagramInstance.current.model = new go.TreeModel(nodes);
            }
            })
            .catch((e) => {
            console.error("Error fetching inventory suggestion:", e);
            });
    };


    useEffect(() => {
        loadParentData()
        if(parentName !== ''){
            loadData()
        }
    }, [parentName]);

    useEffect(() => {
        if (!diagramRef.current) return;

        const $ = go.GraphObject.make;

        const diagram = $(go.Diagram, diagramRef.current, {
            'undoManager.isEnabled': true,
            layout: $(go.TreeLayout, {
                angle: 0,
                layerSpacing: 50,
            }),
        });

        diagram.nodeTemplate = $(
            go.Node, 'Auto',
            $(go.Shape, 'RoundedRectangle', { fill: 'white', strokeWidth: 1, stroke: 'gray' }),
            $(go.TextBlock, { margin: 8, font: '14px karla' },
                new go.Binding('text', 'name')
            )
        );

        diagram.linkTemplate = $(
            go.Link,
            { routing: go.Link.Orthogonal, corner: 0 },
            $(go.Shape, { stroke: '#BF1D2D', strokeWidth: 2 }),
            $(go.Shape, { toArrow: '' })
        );

        diagramInstance.current = diagram;

        return () => {
            if (diagramInstance.current) {
                diagramInstance.current.div = null;
            }
        };
    }, []);

    const accept = () => {
        if (!diagramInstance.current) return;

        const nodeDataArray = diagramInstance.current.model.nodeDataArray;

        const nodeMap = new Map();
        nodeDataArray.forEach(node => {
            nodeMap.set(node.key, { ...node, child: [] });
        });

        nodeDataArray.forEach(node => {
            if (node.parent) {
                const parentNode = nodeMap.get(node.parent);
                if (parentNode) {
                    parentNode.child.push(nodeMap.get(node.key));
                }
            }
        });

        const root = nodeMap.get(parentName);

        const transformNode = (node) => {
            return {
                name: `${node.name}`,
                type: 'location',
                child: node.child.map(transformNode),
            };
        };

        const payload = {
            parent_name: `${root.name}`,
            child: root.child.map(transformNode),
        };

        ApiService.post("/add-inventory-suggestion", payload)
            .then((data) => {
                toast.success(data?.message);
                navigate('/firehouse/inventory');
            })
            .catch((error) => {
                toast.error(error?.data?.message || 'Something went wrong');
            });
    };


    return (
        <>
            <Box sx={{ height: '69px', backgroundColor: '#fff', textAlign: 'end', marginBottom: '30px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Box>
                        <Button
                            variant="contained"
                            className='px-4'
                            sx={{
                                backgroundColor: '#FFC0C6',
                                color: '#000',
                                fontSize: '15px',
                                fontWeight: '700',
                                borderRadius: '8px',
                                marginLeft: '20px',
                                marginTop: '10px',
                                '&:hover': {
                                    backgroundColor: '#FFC0C6',
                                    color: '#000',
                                },
                            }}
                        >
                            Suggestions for Inventory
                        </Button>
                    </Box>
                    <Box>
                        <Typography sx={{
                            fontSize: '22px',
                            fontWeight: 700,
                            color: '#BF1D2D',
                            marginTop: '10px',
                        }}>
                            FireHouse 247
                        </Typography>
                    </Box>
                    <Box>
                        <FormControl variant="outlined">
                            <OutlinedInput
                                id="outlined-adornment-weight"
                                aria-describedby="outlined-weight-helper-text"
                                placeholder='Search'
                                sx={{
                                    height: '40px',
                                    borderRadius: '60px',
                                    marginRight: '80px',
                                    width: '270px',
                                    marginTop: '14px',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#BF1D2D',
                                    },
                                    '& input::placeholder': {
                                        color: '#BF1D2D',
                                    },
                                }}
                            />
                        </FormControl>
                    </Box>
                </div>
            </Box>

            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <p style={{ fontSize: '16px', width: '400px', textAlign: 'center' }}>
                    Start building your inventory today – check out these helpful suggestions!
                </p>
            </div>

            <div style={{ height: '70%' }}>
                <div ref={diagramRef} style={{ width: '100%', height: '100%', background: '#f5f5f5' }} />
            </div>

            <div style={{ display: 'flex', alignItems: 'center' }}>
                <ButtonTheme type='submit' variant="filled" color='primary' onClick={accept}>
                    Accept
                </ButtonTheme>
                <Link to="/firehouse/inventory">
                    <ButtonTheme type='submit' variant="filled" color='primary' className='mx-3'>
                        No , I want to build my own inventory
                    </ButtonTheme>
                </ Link>
            </div>

        </>
    )
}

export default SuggestionBox